/**
 * Validate service selection step
 * @param {string} selectedService - Selected service ID
 * @returns {string|null} - Error message or null if valid
 */
export const validateServiceStep = (selectedService) => {
  if (!selectedService) {
    return "Please select a service";
  }
  return null;
};

/**
 * Validate date and time selection step
 * @param {Date|null} selectedDate - Selected date
 * @param {string} selectedTime - Selected time slot
 * @returns {string|null} - Error message or null if valid
 */
export const validateDateTimeStep = (selectedDate, selectedTime) => {
  if (!selectedDate || !selectedTime) {
    return "Please select a date and time";
  }
  return null;
};

/**
 * Validate vehicle details step
 * @param {object} vehicle - Vehicle object
 * @returns {string|null} - Error message or null if valid
 */
export const validateVehicleStep = (vehicle) => {
  if (!vehicle.make || !vehicle.model || !vehicle.license_plate) {
    return "Please fill in vehicle details";
  }
  return null;
};

/**
 * Validate client details step
 * @param {object} client - Client object
 * @param {object} location - Location object
 * @returns {string|null} - Error message or null if valid
 */
export const validateClientStep = (client, location) => {
  if (!client.name || !client.email || !client.phone) {
    return "Please fill in all contact details";
  }
  if (!location.drop_off_location && !client.address) {
    return "Please enter your service address";
  }
  return null;
};
